/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { ButtonPrimary } from '@core/ButtonPrimary';
import PropTypes from 'prop-types';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import Icons from '@core/Utils/Icons/Icons';
import { useA11y } from '@context/Utils';

export function PopupText({
  isOpen = false,
  icon = appIconsPath.CAUTION,
  title = '',
  desc = '',
  buttonLabel = '',
  onButtonClick = () => {},
  showCloseButton = true,
  onClose = () => {},
  footerChildren = null
}) {
  const { tA11yTranslate } = useA11y();
  const titleContent = tA11y(title);
  const descContent = tA11y(desc);

  useEffect(() => {
    if (isOpen) {
      const modal = document.getElementById('modal-view');
      const focusableElements = modal.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          if (e.shiftKey) { // Shift + Tab
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else { // Tab
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div id="modal-view" className="modal d-block fade show bg-ek-lightblue">
          <div className="d-flex align-items-center justify-content-center h-100">
            <AppPageContentWrapper isDefaultPadding={false} bgColor="w-100 position-relative">
              <div className="bg-ek-gradient rounded-5 w-100 px-20 py-40 position-relative">
                {showCloseButton && <div className="position-absolute top-0 end-0 mt-20 me-20">
                  <button
                    className="bg-transparent border-0"
                    type="button"
                    onClick={onClose}
                    aria-label={tA11yTranslate('ek_global_icn_close_aria').ariaLabel}>
                      <Icons className="filter-ek-white" colorType='dark' name='CLOSE' />
                  </button>
                </div>}
                <div className="modal-body p-0 border-0 text-center">
                  <img className="filter-ek-white" src={icon} alt={tA11yTranslate('ek_global_icn_close_aria').ariaLabel} />
                  <div className="my-40">
                    {titleContent.isHtml ? (
                      <h2
                        className="text-white"
                        dangerouslySetInnerHTML={{ __html: sanitizeRichText(titleContent.content) }}
                      />
                    ) : (
                      <h2 className="text-white">{titleContent.content}</h2>
                    )}
                    {descContent.isHtml ? (
                      <p
                        className="text-white ek-copy-sm-14-regular mt-24"
                        dangerouslySetInnerHTML={{ __html: sanitizeRichText(descContent.content) }}
                      />
                    ) : (
                      <p className="text-white ek-copy-sm-14-regular mt-24">
                        {descContent.content}
                      </p>
                    )}
                  </div>
                </div>
                <div className="border-0 p-0 w-100 justify-content-center text-center">
                  {!footerChildren ? (
                    <div className="row">
                      <div className="col-12">
                        <ButtonPrimary
                          buttonClass=""
                          buttonType={appButtonType.SECONDARY}
                          label={buttonLabel}
                          onClick={onButtonClick}
                        />
                      </div>
                    </div>
                  ) : (
                    footerChildren
                  )}
                </div>
              </div>
            </AppPageContentWrapper>
          </div>
        </div>
      )}
    </>
  );
}

PopupText.propTypes = {
  isOpen: PropTypes.bool,
  icon: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  buttonLabel: PropTypes.string,
  onButtonClick: PropTypes.func,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func
};

export default PopupText;
